module.exports = __webpack_public_path__ + "assets/wp-engine.265d90c1.svg";